import addMilliseconds from 'date-fns/addMilliseconds';
import { getTimezoneOffset } from 'date-fns-tz';
import { differenceInDays, parseISO, isValid, isBefore } from 'date-fns';

export const CAMPAIGN_TIME_OPTIONS = [
  {
    id: '0000',
    label: '12:00 AM',
    value: '00:00',
  },
  {
    id: '0015',
    label: '12:15 AM',
    value: '00:15',
  },
  {
    id: '0030',
    label: '12:30 AM',
    value: '00:30',
  },
  {
    id: '0045',
    label: '12:45 AM',
    value: '00:45',
  },
  {
    id: '0100',
    label: '1:00 AM',
    value: '01:00',
  },
  {
    id: '0115',
    label: '1:15 AM',
    value: '01:15',
  },
  {
    id: '0130',
    label: '1:30 AM',
    value: '01:30',
  },
  {
    id: '0145',
    label: '1:45 AM',
    value: '01:45',
  },
  {
    id: '0200',
    label: '2:00 AM',
    value: '02:00',
  },
  {
    id: '0215',
    label: '2:15 AM',
    value: '02:15',
  },
  {
    id: '0230',
    label: '2:30 AM',
    value: '02:30',
  },
  {
    id: '0245',
    label: '2:45 AM',
    value: '02:45',
  },
  {
    id: '0300',
    label: '3:00 AM',
    value: '03:00',
  },
  {
    id: '0315',
    label: '3:15 AM',
    value: '03:15',
  },
  {
    id: '0330',
    label: '3:30 AM',
    value: '03:30',
  },
  {
    id: '0345',
    label: '3:45 AM',
    value: '03:45',
  },
  {
    id: '0400',
    label: '4:00 AM',
    value: '04:00',
  },
  {
    id: '0415',
    label: '4:15 AM',
    value: '04:15',
  },
  {
    id: '0430',
    label: '4:30 AM',
    value: '04:30',
  },
  {
    id: '0445',
    label: '4:45 AM',
    value: '04:45',
  },
  {
    id: '0500',
    label: '5:00 AM',
    value: '05:00',
  },
  {
    id: '0515',
    label: '5:15 AM',
    value: '05:15',
  },
  {
    id: '0530',
    label: '5:30 AM',
    value: '05:30',
  },
  {
    id: '0545',
    label: '5:45 AM',
    value: '05:45',
  },
  {
    id: '0600',
    label: '6:00 AM',
    value: '06:00',
  },
  {
    id: '0615',
    label: '6:15 AM',
    value: '06:15',
  },
  {
    id: '0630',
    label: '6:30 AM',
    value: '06:30',
  },
  {
    id: '0645',
    label: '6:45 AM',
    value: '06:45',
  },
  {
    id: '0700',
    label: '7:00 AM',
    value: '07:00',
  },
  {
    id: '0715',
    label: '7:15 AM',
    value: '07:15',
  },
  {
    id: '0730',
    label: '7:30 AM',
    value: '07:30',
  },
  {
    id: '0745',
    label: '7:45 AM',
    value: '07:45',
  },
  {
    id: '0800',
    label: '8:00 AM',
    value: '08:00',
  },
  {
    id: '0815',
    label: '8:15 AM',
    value: '08:15',
  },
  {
    id: '0830',
    label: '8:30 AM',
    value: '08:30',
  },
  {
    id: '0845',
    label: '8:45 AM',
    value: '08:45',
  },
  {
    id: '0900',
    label: '9:00 AM',
    value: '09:00',
  },
  {
    id: '0915',
    label: '9:15 AM',
    value: '09:15',
  },
  {
    id: '0930',
    label: '9:30 AM',
    value: '09:30',
  },
  {
    id: '0945',
    label: '9:45 AM',
    value: '09:45',
  },
  {
    id: '1000',
    label: '10:00 AM',
    value: '10:00',
  },
  {
    id: '1015',
    label: '10:15 AM',
    value: '10:15',
  },
  {
    id: '1030',
    label: '10:30 AM',
    value: '10:30',
  },
  {
    id: '1045',
    label: '10:45 AM',
    value: '10:45',
  },
  {
    id: '1100',
    label: '11:00 AM',
    value: '11:00',
  },
  {
    id: '1115',
    label: '11:15 AM',
    value: '11:15',
  },
  {
    id: '1130',
    label: '11:30 AM',
    value: '11:30',
  },
  {
    id: '1145',
    label: '11:45 AM',
    value: '11:45',
  },
  {
    id: '1200',
    label: '12:00 PM',
    value: '12:00',
  },
  {
    id: '1215',
    label: '12:15 PM',
    value: '12:15',
  },
  {
    id: '1230',
    label: '12:30 PM',
    value: '12:30',
  },
  {
    id: '1245',
    label: '12:45 PM',
    value: '12:45',
  },
  {
    id: '1300',
    label: '1:00 PM',
    value: '13:00',
  },
  {
    id: '1315',
    label: '1:15 PM',
    value: '13:15',
  },
  {
    id: '1330',
    label: '1:30 PM',
    value: '13:30',
  },
  {
    id: '1345',
    label: '1:45 PM',
    value: '13:45',
  },
  {
    id: '1400',
    label: '2:00 PM',
    value: '14:00',
  },
  {
    id: '1415',
    label: '2:15 PM',
    value: '14:15',
  },
  {
    id: '1430',
    label: '2:30 PM',
    value: '14:30',
  },
  {
    id: '1445',
    label: '2:45 PM',
    value: '14:45',
  },
  {
    id: '1500',
    label: '3:00 PM',
    value: '15:00',
  },
  {
    id: '1515',
    label: '3:15 PM',
    value: '15:15',
  },
  {
    id: '1530',
    label: '3:30 PM',
    value: '15:30',
  },
  {
    id: '1545',
    label: '3:45 PM',
    value: '15:45',
  },
  {
    id: '1600',
    label: '4:00 PM',
    value: '16:00',
  },
  {
    id: '1615',
    label: '4:15 PM',
    value: '16:15',
  },
  {
    id: '1630',
    label: '4:30 PM',
    value: '16:30',
  },
  {
    id: '1645',
    label: '4:45 PM',
    value: '16:45',
  },
  {
    id: '1700',
    label: '5:00 PM',
    value: '17:00',
  },
  {
    id: '1715',
    label: '5:15 PM',
    value: '17:15',
  },
  {
    id: '1730',
    label: '5:30 PM',
    value: '17:30',
  },
  {
    id: '1745',
    label: '5:45 PM',
    value: '17:45',
  },
  {
    id: '1800',
    label: '6:00 PM',
    value: '18:00',
  },
  {
    id: '1815',
    label: '6:15 PM',
    value: '18:15',
  },
  {
    id: '1830',
    label: '6:30 PM',
    value: '18:30',
  },
  {
    id: '1845',
    label: '6:45 PM',
    value: '18:45',
  },
  {
    id: '1900',
    label: '7:00 PM',
    value: '19:00',
  },
  {
    id: '1915',
    label: '7:15 PM',
    value: '19:15',
  },
  {
    id: '1930',
    label: '7:30 PM',
    value: '19:30',
  },
  {
    id: '1945',
    label: '7:45 PM',
    value: '19:45',
  },
  {
    id: '2000',
    label: '8:00 PM',
    value: '20:00',
  },
  {
    id: '2015',
    label: '8:15 PM',
    value: '20:15',
  },
  {
    id: '2030',
    label: '8:30 PM',
    value: '20:30',
  },
  {
    id: '2045',
    label: '8:45 PM',
    value: '20:45',
  },
  {
    id: '2100',
    label: '9:00 PM',
    value: '21:00',
  },
  {
    id: '2115',
    label: '9:15 PM',
    value: '21:15',
  },
  {
    id: '2130',
    label: '9:30 PM',
    value: '21:30',
  },
  {
    id: '2145',
    label: '9:45 PM',
    value: '21:45',
  },
  {
    id: '2200',
    label: '10:00 PM',
    value: '22:00',
  },
  {
    id: '2215',
    label: '10:15 PM',
    value: '22:15',
  },
  {
    id: '2230',
    label: '10:30 PM',
    value: '22:30',
  },
  {
    id: '2245',
    label: '10:45 PM',
    value: '22:45',
  },
  {
    id: '2300',
    label: '11:00 PM',
    value: '23:00',
  },
  {
    id: '2315',
    label: '11:15 PM',
    value: '23:15',
  },
  {
    id: '2330',
    label: '11:30 PM',
    value: '23:30',
  },
  {
    id: '2345',
    label: '11:45 PM',
    value: '23:45',
  },
];

export const getTZTime = ({
  date,
  time,
  timezone,
}: {
  date: string;
  time: string;
  timezone: string;
}): Date | null => {
  const utcTime = `${date}T${time}:00.000Z`;

  const utcDateTime = new Date(utcTime);
  const tzOffset = getTimezoneOffset(timezone, utcDateTime);
  const tzTime = addMilliseconds(utcDateTime, -tzOffset);

  const currentUTCTime = Date.now(),
    selectedUTCTime = tzTime.getTime();
  return selectedUTCTime > currentUTCTime ? tzTime : null;
};

export const convertTimeLabelToValue = (label: string): string => {
  const [hours, minutes] = label.trim().toLowerCase().split(':');
  const mins = minutes.trim();
  const min = mins.slice(0, 2);
  const meridiem = mins.slice(2).trim().toLowerCase();
  const hour =
    meridiem === 'am'
      ? Number(hours) === 12
        ? '00'
        : Number(hours) < 10
        ? `0${hours}`
        : hours
      : Number(hours) < 12
      ? Number(hours) + 12
      : hours;

  return `${hour}:${min}`;
};

export const convertTimeValueToLabel = (value: string): string => {
  const [hrs, mins] = value.split(':').map(Number);
  const meridiem = hrs > 11 ? 'PM' : 'AM';
  const hours = hrs > 12 ? hrs - 12 : hrs === 0 ? 12 : hrs;
  const min = mins < 10 ? `0${mins}` : `${mins}`;
  return `${hours}:${min} ${meridiem}`;
};

export const isTimeInputValidTillNow = (str: string): boolean => {
  if (!str) return true;
  const [hours, minsMeridiem] = str?.trim().toLowerCase().split(':');

  try {
    const hour = Number(hours);

    if (!(hour >= 0 && hour <= 23)) return false;

    const minMeridiem = minsMeridiem?.trim();

    if (minMeridiem) {
      const minStr = minMeridiem.slice(0, 2).trim();

      if (minStr.length === 1) {
        if (Number(minStr) > 5 || minMeridiem.length !== 1) return false;
      } else if (minStr.length !== 2) return false;

      const min = Number(minStr);

      if (!(min >= 0 && min <= 59)) return false;

      const meridiem = minMeridiem.slice(2).trim();

      if (!meridiem) return true;

      if (hour > 12 && (meridiem === 'a' || meridiem === 'am')) return false;

      if (
        !(
          meridiem === 'a' ||
          meridiem === 'am' ||
          meridiem === 'p' ||
          meridiem === 'pm'
        )
      )
        return false;

      return true;
    } else {
      return true;
    }
  } catch {
    return false;
  }
};

export const isTimeInputValid = (str: string): boolean => {
  try {
    const [hours, minsMeridiem] = str.trim().toLowerCase().split(':');
    const hour = Number(hours.trim());
    const minMeridiem = minsMeridiem.trim();
    const minStr = minMeridiem.slice(0, 2);

    if (minStr.trim().length !== 2) return false;

    const min = Number(minStr);

    const meridiem = minMeridiem.slice(2).trim();

    if (hour > 12 && meridiem === 'am') return false;

    const valid =
      hour >= 0 &&
      hour <= 23 &&
      min >= 0 &&
      min <= 59 &&
      (meridiem === 'am' || meridiem === 'pm');

    return valid;
  } catch (error) {
    return false;
  }
};

export const convertToDuration = (milliSeconds: number): string => {
  let seconds = Math.floor(milliSeconds / 1000);
  const hours = Math.floor(seconds / 3600);
  seconds -= hours * 3600;
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  return hours > 0
    ? `${hours.toLocaleString()}h ${minutes}m`
    : `${minutes}m ${seconds}s`;
};

export const getDaysPassed = (appliedDate: string): number => {
  const applied = parseISO(appliedDate);
  const now = new Date();
  return differenceInDays(now, applied);
};

export const isValidDate = (date: string | Date | null): boolean => {
  if (!date) return false;
  const parsedDate = typeof date === 'string' ? parseISO(date) : date;
  return isValid(parsedDate);
};

export const isBefore1OCT2023 = (date: string | Date | null): boolean => {
  if (!date) return false;
  return isBefore(new Date(date), new Date('2023-08-01T00:00:00.000Z'));
};

export const convertToTimeZone = (
  targetTimeZone: string,
  date?: string
): string => {
  const currentDate: Date = date ? new Date(date) : new Date();

  return currentDate.toLocaleString('en-GB', {
    timeZone: targetTimeZone,
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const getDayDateAndTime = (date: Date) => {
  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  const formattedDateTime = {
    dayOfWeek: dayOfWeek,
    month: month,
    day: day,
    year: year,
    time24Hour: `${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}`,
    timeAMPM: `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`,
  };

  return formattedDateTime;
};
